import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/parameters';

@Pipe({
  name: 'lang',
  pure: true,
})
export class LangPipe implements PipeTransform {

  constructor(
    private languageService: LanguageService
  ) { }

  public transform(value: any, args?: any): string {
    const message = this.languageService.message(value, args);
    return message;
  }
}
